import { BitmapImage, Emitter, Linear } from "@quest/pixi-bridge";
import { WinCollectionTrailView } from "./WinCollectionTrailView";
import { Bitmap, Container, detectDeviceEnvironmentConstants, dispatcher, ingenuity } from "@quest/base-core";
import { IEvent, IObject, ITween } from "@quest/adapter-interface";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SlotConstants } from "@quest/slot-core";

export class WinCollectionTrailController {
      private finalX:number;
      private finalY: number;
      private trailCounter: number = 0;
      private tweenArray: ITween[] = [];
      // Particle Data
  private particleData: any = {
    emitterType: 1,
    id: "coinEmitter_1",
    autoStart: false,
    animConfig: [
      {
        framerate: 20,
        loop: true,
        image: "orange",
        generateFrames: false,
        frame: 0,
      },
    ],
  };
  private particleConfig: any = {
    alpha: {
      start: 1,
      end: 0,
    },
    scale: {
      start: 3,
      end: 0.6,
      minimumScaleMultiplier: 1,
    },
     color: {
      start: "#ffffff",
      end: "#ffffff",
    },
    speed: {
      start: 0,
      end: 0,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 0,
    },
    maxSpeed: 0,
    lifetime: {
      min: 0.2,
      max: 1,
    },
    blendMode: "screen",
    frequency: 0.001,
    emitterLifetime: -1,
    maxParticles: 300,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: "point"
  };
    private readonly view : WinCollectionTrailView;

    constructor(viewJson:WinCollectionTrailView){
        this.view = viewJson;
        this.subscribeEvents();
    }


    private subscribeEvents():void{
        this.unSubscribeEvents();
        dispatcher.on(eventDispatchers.RESET_WIN_COLLECTION_COIN_TRAIL, this.resetBonusTrailData, this);
        dispatcher.on(eventDispatchers.UPDATE_FINAL_POSITION, this.getFinalPosition, this);
        dispatcher.on(eventDispatchers.PLAY_WIN_COLLECTION_COIN_TRAIL,this.startCoinTrail,this)
    } 
    private unSubscribeEvents():void{
        dispatcher.off(eventDispatchers.RESET_WIN_COLLECTION_COIN_TRAIL, this.resetBonusTrailData, this);
        dispatcher.off(eventDispatchers.UPDATE_FINAL_POSITION, this.getFinalPosition, this);
        dispatcher.off(eventDispatchers.PLAY_WIN_COLLECTION_COIN_TRAIL,this.startCoinTrail,this)
    }     

    private startCoinTrail(evt:IEvent):void{
        let row : number = evt.data.row;
        let col : number = evt.data.col;
        let index : number = evt.data.index;
        this.playTrailAnimation(col, row,index);
    }

      /**
   * This method is use to play bonus trail animation from reel to pot
   */
  private playTrailAnimation(col: number, row: number,index:number): void {
    //Use to create trail image
    let smokeSprite: any = this.createTrailImage(col, row);
    //Use to create trail emitter
    this.createTrailEmitter(smokeSprite, col);
    //Use to play trail animation on each bonus landed
    this.tostartTrail(col, row, smokeSprite,index);
    this.trailCounter += 1;
  }

  /**
   * This method is use to create trail image
   */
  private createTrailImage(colNum: number, rowNum: number): BitmapImage {
    let smokeSprite: BitmapImage = new BitmapImage(ingenuity.currentGame, 0, 0, this.view.json.smokeSprite.id);
    smokeSprite.x = this.view.json.smokeSpriteXY[colNum][rowNum][0];
    smokeSprite.y = this.view.json.smokeSpriteXY[colNum][rowNum][1];
    smokeSprite.name = this.view.json.smokeSprite.name + colNum + rowNum;
    this.particleData.id = this.view.json.smokeSprite.id + colNum + rowNum;
    smokeSprite.alpha = this.view.json.smokeSprite.alpha;
    smokeSprite.scale.set(this.view.json.smokeSprite.scale);
    smokeSprite.anchor.set(this.view.json.smokeSprite.anchorX, this.view.json.smokeSprite.anchorY);
    let smoke: Bitmap = this.view.getImageById("blueParticle");
    smoke.parent.addChild(smokeSprite);
    return smokeSprite;
  }


  /**
   * This method create emitter for trail
   */
  private createTrailEmitter(smokeSprite: BitmapImage, col: number): void {
    const particle: Emitter = ingenuity.currentGame.add.emitter(
      this.view.getContainerByID("trailAnimationContainer_" + col),
      this.particleData,
      this.particleConfig
    ) as Emitter;
    particle.autoUpdate = true;
    particle.emit = true;
    particle.updateOwnerPos(smokeSprite.x, smokeSprite.y);
  }



  /**
   * This method is use to start trail
   */
  private tostartTrail(colNum: number, rowNum: number, smokeSprite: BitmapImage, index:number): void {
    this.getFinalPosition();
    let counter: number = this.trailCounter;
    let curveVal = 0.7;
    let startPosX = this.view.json.smokeSpriteXY[colNum][rowNum][0];
    let startPosY = this.view.json.smokeSpriteXY[colNum][rowNum][1];
    let endPosX = this.finalX;
    let endPosY = this.finalY;
    let position = this.bezierCurve(startPosX, startPosY, endPosX, endPosY, curveVal);
    this.tweenArray.push(
      ingenuity.currentGame.add
        .tween(smokeSprite)
        .to({ x: position[0], y: position[1] }, this.view.json.trailTimers[colNum][rowNum], undefined, true)
    );
    this.tweenArray[counter].onComplete.addOnce(() => {
      if(!ingenuity.configData.moneyHuntingSkipPressed){
      if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState) {
        dispatcher.fireEvent(eventDispatchers.START_WIN_COLLECTION);
        dispatcher.fireEvent(eventDispatchers.PLAY_BLAST_ON_WIN_METER);
      } else {
        dispatcher.fireEvent(eventDispatchers.START_WIN_COLLECTION_FG);
        dispatcher.fireEvent(eventDispatchers.PLAY_BLAST_ON_WIN_METER_FG);
      }
    }
      ingenuity.currentGame.particles.getEmitterById(this.tweenArray[counter].target.name).emit = false;
      let trailAlphaTween: ITween = ingenuity.currentGame.add
        .tween(this.view.getContainerByID("trailAnimationContainer_" + colNum))
        .to({ alpha: 0 }, SlotConstantsBehavior.DURATION_400, Linear.None, true, 0, 0, false);
      trailAlphaTween.onComplete.addOnce(() => {
        let em: Emitter;
        em = ingenuity.currentGame.particles.getEmitterById(this.tweenArray[counter].target.name);
        em && (em.autoUpdate = false);
        em && em.destroy();
        this.view.getContainerByID("trailAnimationContainer_" + colNum).alpha = 1;
        this.tweenArray[counter].stop();
        this.tweenArray[counter].onUpdateCallback = null;
        ingenuity.currentGame.tweens.remove(this.tweenArray[counter]);
        this.tweenArray[counter].target.parent.removeChild(this.tweenArray[counter].target);
      }, this);
    }, this);

    this.tweenArray[counter].onUpdateCallback((evt: IObject) => {
      let em: Emitter;
      em = ingenuity.currentGame.particles.getEmitterById(evt.target.name);
      em && em.updateOwnerPos(evt.target.x, evt.target.y);
    });
  }

   private getFinalPosition():void{
      if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
        this.finalX = this.view.json.finalPosPortrait[0];
        this.finalY = this.view.json.finalPosPortrait[1];
      } else {
        this.finalX = this.view.json.finalPosDesktop[0];
        this.finalY = this.view.json.finalPosDesktop[1];
      }
  }


  

  // Add to reset bonus trail data
  private resetBonusTrailData(): void {
    this.tweenArray = [];
    this.trailCounter = 0;
    const trailAnimationContainer: Container = this.view.getContainerByID("trailAnimationContainer");
    trailAnimationContainer.children.forEach((child: Container) => {
      child.children = [];
    });
  }

  //create a curve path array position
  private bezierCurve(startX: number, startY: number, endX: number, endY: number, curveFactor: number): number[][] {
    // startX: X-coordinate of the starting point of the line
    // startY: Y-coordinate of the starting point of the line
    // endX: X-coordinate of the ending point of the line
    // endY: Y-coordinate of the ending point of the line
    // curveFactor: Factor determining the amount of curvature in the curve

    // Calculate control point coordinates
    const controlX = (startX + endX) / 2 - Math.abs(startX - endX) * curveFactor; // X-coordinate of the control point (midpoint)
    const controlY = (startY + endY) / 2; // Y-coordinate of the control point

    // Arrays to store X and Y coordinates of points along the curve
    let curveX: number[] = []; // Array to store X coordinates
    let curveY: number[] = []; // Array to store Y coordinates

    // Number of points to calculate along the curve
    const numberOfPoints = 50; // You can adjust this value based on the desired smoothness of the curve

    // Loop to calculate coordinates of points along the curve
    for (let i = 0; i <= numberOfPoints; i++) {
      const t = i / numberOfPoints; // Parameterization along the Bézier curve (ranges from 0 to 1)
      const x = Math.pow(1 - t, 2) * startX + 2 * (1 - t) * t * controlX + Math.pow(t, 2) * endX; // X-coordinate of the point on the curve
      const y = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY; // Y-coordinate of the point on the curve
      curveX.push(x); // Add X-coordinate to the array
      curveY.push(y); // Add Y-coordinate to the array
    }

    // Return arrays of X and Y coordinates of points along the curve
    return [curveX, curveY];
  }
}